import { URL } from "../../config";
function getCurrencyImageLink(imgName) {
    return `${URL.server}/images/${imgName}.png`;
}
export { getCurrencyImageLink };
